<div class="app-wrapper" [class]="envClass">

  <app-subscription-banner *ngIf="isLoggedIn"></app-subscription-banner>
  
  <mat-toolbar color="primary" class="main-toolbar mat-elevation-z2">
    <span class="brand-title" style="cursor: pointer;" routerLink="/dashboard">
      <span class="brand-bold">Your</span>Notes<span class="brand-dot">:</span>
      <span class="tagline">Focus on what matters. Deliver what counts.</span>
    </span>
    <span class="spacer"></span>

    <ng-container *ngIf="!isLoggedIn">
      <div class="auth-buttons">
        <button mat-button class="register-btn" (click)="loginModal()">LOG IN</button>
        <button mat-stroked-button class="register-btn" (click)="registerModal()">REGISTER</button>
      </div>
    </ng-container>

    <ng-container *ngIf="isLoggedIn">
      <button mat-icon-button routerLink="/account"><mat-icon>account_circle</mat-icon></button>
    </ng-container>
  </mat-toolbar>

  <mat-sidenav-container class="main-container" [hasBackdrop]="false" autosize="true">
    <mat-sidenav mode="side" opened="true" class="nav-rail" [disableClose]="true" *ngIf="isLoggedIn">
      <div class="rail-content">

        <a class="rail-button" routerLink="/dashboard" routerLinkActive="active-rail" matTooltip="Dashboard">
          <mat-icon>space_dashboard</mat-icon>
        </a>
        <a class="rail-button" routerLink="/notes" routerLinkActive="active-rail" matTooltip="Notes">
          <mat-icon>subject</mat-icon>
        </a>
        <a class="rail-button" routerLink="/tasks" routerLinkActive="active-rail" matTooltip="Tasks">
          <mat-icon>view_kanban</mat-icon>
        </a>
        <a class="rail-button" routerLink="/lists" routerLinkActive="active-rail" matTooltip="Lists">
          <mat-icon>checklist</mat-icon>
        </a>

        <span class="spacer"></span>

        <a class="rail-button" routerLink="/settings" routerLinkActive="active-rail" matTooltip="Settings">
          <mat-icon>settings</mat-icon>
        </a>

        <a *hasRole="'ADMIN'" class="rail-button" routerLink="/admin" routerLinkActive="active-rail" matTooltip="Admin">
          <mat-icon>admin_panel_settings</mat-icon>
        </a>
        
        <button class="rail-button logout-rail" (click)="logout()" matTooltip="Logout">
          <mat-icon>logout</mat-icon>
        </button>
      </div>
    </mat-sidenav>

    <mat-sidenav-content>
      <mat-sidenav-container [hasBackdrop]="true">

        <mat-sidenav-content class="page-content">
          <router-outlet></router-outlet>

        </mat-sidenav-content>
      </mat-sidenav-container>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>